<template>
  <div>
    <div class="sidebar-heading d-flex align-center justify-start mb-5">
      <v-icon class="mr-2" color="primary" :size="defaultIconSize">
        $page
      </v-icon>
      <h3 class="regular-action-title sidebar-heading mb-0">
        {{ $t("chapter.video.videoSettings") }}
      </h3>
    </div>
    <v-expansion-panels
      flat
      class="chapter-details-expansion-panels"
      :value="0"
    >
      <v-expansion-panel class="mb-3 pa-0">
        <v-expansion-panel-header
          expand-icon="$chevronDown"
          class="d-flex align-center justify-start px-3 py-2"
        >
          <div class="ml-2">{{ $t("chapter.video.videoContents") }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="editor" class="pa-2 pb-5">
            <v-hover>
              <template v-slot:default="{ hover }">
                <div :class="'select-media-container' + (!videoUrl ? ' placeholder' : '')">
                  <video
                    v-if="videoUrl"
                    class="video-preview"
                    :key="videoUrl"
                  >
                    <source :src="videoUrl" />
                  </video>
                  <div :class="videoUrl ? null : 'py-15'">
                    <v-fade-transition>
                      <v-overlay
                        content-class="media-object-upload-overlay-content"
                        v-show="
                          (hover && !loading) || !videoUrl || videoUrl == ''
                        "
                        :color="imageUrl ? 'black' : 'transparent'"
                        absolute
                      >
                        <MediaObjectUpload
                          v-model="uploadUrl"
                          :addText="$t('chapter.video.chooseVideo')"
                          :changeText="$t('chapter.video.chooseVideo')"
                          @error="setErrorMessage"
                          @loading="loading = $event"
                          :errorTooLargeMessage="
                            $t('chapter.video.videoTooLarge', {
                              maxVideoSize: MAX_VIDEO_UPLOAD_MEGABYTES,
                            })
                          "
                          :maxSizeBytes="MAX_VIDEO_UPLOAD_BYTES"
                          :formats="VIDEO_FORMATS"
                        />
                      </v-overlay>
                    </v-fade-transition>
                  </div>
                </div>
              </template>
            </v-hover>
          <span class="error-text">{{ errorMessage }}</span>
          <div class="text-left my-3" v-if="loading">
            {{ $t("forms.uploading") }}
            <v-progress-linear
              indeterminate
              color="primaryAction darken-2"
            ></v-progress-linear>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import MediaObjectUpload from "@/components/MediaObjectUpload";
import {
  VIDEO_FORMATS,
  MAX_VIDEO_UPLOAD_MEGABYTES,
  MAX_VIDEO_UPLOAD_BYTES,
  GRADIENTS,
  DEFAULT_ICON_SIZE,
} from "@/const";
const EXTENSION_NAME = "video";

export default {
  props: {
    editor: Object,
  },
  components: {
    MediaObjectUpload,
  },
  data() {
    return {
      loading: false,
      uploadUrl: null,
      errorMessage: "",
    };
  },
  methods: {
    setErrorMessage(message) {
      this.errorMessage = message;
    },
  },
  computed: {
    VIDEO_FORMATS() {
      return VIDEO_FORMATS;
    },
    MAX_VIDEO_UPLOAD_MEGABYTES() {
      return MAX_VIDEO_UPLOAD_MEGABYTES;
    },
    MAX_VIDEO_UPLOAD_BYTES() {
      return MAX_VIDEO_UPLOAD_BYTES;
    },
    isActive() {
      return this.editor.isActive(EXTENSION_NAME);
    },
    videoUrl() {
      return this.editor.getAttributes(EXTENSION_NAME).src;
    },
    gradients() {
      return GRADIENTS;
    },
    defaultIconSize() {
      return DEFAULT_ICON_SIZE;
    },
  },
  watch: {
    uploadUrl(newValue) {
      this.editor.chain().focus().setVideoSrc(newValue).run();
    },
    videoUrl(newValue) {
      this.uploadUrl = newValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.video-preview {
  height: auto;
  max-width: 100%;
  width: auto;
}
</style>
